import { render, staticRenderFns } from "./UserTaskResponseConfig.vue?vue&type=template&id=151fac18&scoped=true"
import script from "./UserTaskResponseConfig.vue?vue&type=script&lang=js"
export * from "./UserTaskResponseConfig.vue?vue&type=script&lang=js"
import style0 from "./UserTaskResponseConfig.vue?vue&type=style&index=0&id=151fac18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fac18",
  null
  
)

export default component.exports